import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IScoreboardRanking, IServerScoreboardRanking } from '@sociuu/lib/models/scoreboard-stats';
import { environment } from '@utility/app.util';
import { ScoreboardDto } from 'libs/interfaces/src/lib/dto/scoreboard.dto';
import { IScorecard, IServerScorecard, ScoreboardsDto } from 'libs/interfaces/src/lib/dto/scoreboards.dto';
import { catchError, map, Observable, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScoreboardService {
  constructor(private http: HttpClient) {}

  getAllScoreboards(): Observable<ScoreboardDto> {
    return this.http.get<any>(`${environment.sociuuhubApiUrl}/scorecard/all-scorecards/1`);
  }

  public getScorecardStats(id: number, refresh: boolean = undefined): Observable<IScorecard> {
    const refreshParam: string = refresh !== undefined ? `?refresh=${refresh}` : '';

    return this.http.get<{ data: IServerScorecard}>(`${environment.sociuuhubApiUrl}/scoreboards/${id}/stats${refreshParam}`).pipe(
      map(({ data }: { data:  IServerScorecard}): IScorecard => {
        const { participated_in, scoreboard_based_on, scoreboard_display_by, client_currency, total } = data.meta_info;
        return {
          allRankings: this.mapRankings(data.all_rankings),
          currentRankings: this.mapRankings(data.current_rankings),
          metaInfo: {
            ...participated_in !== undefined && { participatedIn:  participated_in },
            scoreboardBasedOn: scoreboard_based_on,
            scoreboardDisplayBy: scoreboard_display_by,
            clientCurrency: client_currency,
            total: total,
          }
        }
      }),
      catchError(error => {
        return throwError(error);
      }));
   }

  private mapRankings(serverRanking: IServerScoreboardRanking[]): IScoreboardRanking[] {
    return serverRanking.map((ranking: IServerScoreboardRanking): IScoreboardRanking => ({
      countTotal: ranking.count_total,
      displayName: ranking.display_name,
      rank: ranking.rank,
    }));
  }


  getScorecardStatss(id: number): Observable<ScoreboardsDto> {
    return this.http.get<any>(`${environment.sociuuhubApiUrl}/scorecard/getScorecardStats/${id}`);
  }

  getScoreboardStats(): Observable<any> {
    return this.getAllScoreboards().pipe(
      switchMap((response: any) => {
        const id = response.data[0].id;

        return this.getScorecardStats(id).pipe(
          map((stats: any) => {
            //spread operator to combine to two objects
            return {
              ...response,
              ...stats,
            };
          })
        );
      })
    );
  }
}
